import comp from "./HistoryGraph";
export default comp;
